import React from "react";
import ActionMenu from "../components/ActionMenu";
import BackBtn from "../components/BackBtn";
import TagFilter from "../components/TagFilter";
import SaveBadge from "../components/SaveBadge";
import { BF, FF } from "../lib/constants";

export default function Weeks({
  mob, pd, lv, sel, data, wks,
  weekFilter, setWeekFilter, canEdit,
  setSelW, setTab, setScr, confirmDel, addWeek,
  duplicateWeek, openCopyWeekTo, moveWeek, openMoveWeek,
  renderModal, sav, savLabel,
  showPublishBanner, publishing, onPublish, justPublished,
}) {
  var filteredWks = wks;
  if (weekFilter.length > 0) {
    filteredWks = wks.filter(function (w) {
      var wk = data[sel][w];
      if (!wk.tags || wk.tags.length === 0) return false;
      return weekFilter.every(function (ft) { return wk.tags.indexOf(ft) >= 0; });
    });
  }

  return (
    <div style={{ minHeight: "100vh", padding: "16px " + pd + "px 40px", fontFamily: FF, maxWidth: 800, margin: "0 auto", background: "#F5F3EE" }}>
      <SaveBadge show={sav} label={savLabel} />
      <BackBtn label="Alle groepen" onClick={function () { setScr("home"); }} />
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16 }}>
        <div style={{ width: 14, height: 14, borderRadius: "50%", background: lv.color }} />
        <h1 style={{ fontFamily: BF, fontSize: mob ? 21 : 26, color: "#1C1B19", fontWeight: 800 }}>{lv.label}</h1>
      </div>
      <TagFilter allTags={buildAllWeekTags(data, sel, wks)} selected={weekFilter} onChange={setWeekFilter} color={lv.color} />
      {/* Zelfde brede kaarten als op het beginscherm: laptop 2 kolommen, telefoon 1. */}
      <div style={{ display: "grid", gridTemplateColumns: mob ? "minmax(0, 1fr)" : "repeat(2, minmax(0, 1fr))", gap: 10 }}>
        {filteredWks.map(function (w) {
          var wd2 = data[sel] ? data[sel][w] : null;
          var has = wd2 && wd2.title;
          var tags = (wd2 && wd2.tags) || [];
          return (
            <div key={w} style={{ position: "relative", minWidth: 0, display: "flex" }}>
              <button onClick={function () { setSelW(w); setTab(0); setScr("lesson"); }} style={{ background: "#fff", border: "2px solid " + (has ? lv.border : "#E2DED5"), borderRadius: 16, padding: canEdit ? "12px 52px 12px 14px" : "12px 18px 12px 14px", cursor: "pointer", textAlign: "left", width: "100%", minHeight: 62, flex: 1, display: "flex", alignItems: "center", gap: 12, fontFamily: FF }}>
                <div style={{ width: 30, height: 30, borderRadius: "50%", flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 800, fontSize: 13, background: has ? lv.color : "#fff", color: has ? (lv.on || "#fff") : "#B5B0A6", border: has ? "none" : "2px solid #E2DED5", boxSizing: "border-box" }}>{w}</div>
                <div style={{ minWidth: 0, flex: 1 }}>
                  <span style={{ display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden", lineHeight: 1.3, overflowWrap: "anywhere", fontFamily: BF, fontSize: 14, fontWeight: 800, color: has ? "#1C1B19" : "#B5B0A6" }}>{has ? wd2.title : "Niet ingevuld"}</span>
                  {tags.length > 0
                    ? <div style={{ display: "flex", gap: 3, flexWrap: "wrap", marginTop: 3 }}>{tags.map(function (t, j) { return <span key={j} style={{ fontSize: 9, fontWeight: 700, textTransform: "uppercase", padding: "1px 6px", borderRadius: 4, background: lv.bg, color: lv.ink || lv.color, border: "1px solid " + lv.border }}>{t}</span>; })}</div>
                    : <span style={{ fontSize: 10, color: "#999" }}>{"Week " + w}</span>}
                </div>
              </button>
              {canEdit && <ActionMenu center items={[
                weekFilter.length === 0 && wks.indexOf(w) > 0 && { icon: "↑", label: "Eerder zetten", onClick: function () { moveWeek(w, wks.indexOf(w)); } },
                weekFilter.length === 0 && wks.indexOf(w) < wks.length - 1 && { icon: "↓", label: "Later zetten", onClick: function () { moveWeek(w, wks.indexOf(w) + 2); } },
                weekFilter.length === 0 && wks.length > 2 && { icon: "⇅", label: "Verplaatsen naar…", onClick: function () { openMoveWeek(w); } },
                { icon: "⧉", label: "Week dupliceren", onClick: function () { duplicateWeek(w); } },
                { icon: "→", label: "Kopiëren naar ander seizoensplan", onClick: function () { openCopyWeekTo(w); } },
                wks.length > 1 && { icon: "×", label: "Week verwijderen", danger: true, onClick: function () { confirmDel("week", w); } },
              ]} />}
            </div>
          );
        })}
        {canEdit && weekFilter.length === 0 && <button onClick={addWeek} style={{ background: "#fff", border: "2px dashed #CFC9BD", borderRadius: 16, padding: "12px 14px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: 8, color: "#999", minHeight: 62, fontFamily: FF }}><span style={{ fontSize: 20 }}>+</span><span style={{ fontFamily: BF, fontSize: 12, fontWeight: 800 }}>Week toevoegen</span></button>}
      </div>
      {wks.length === 0 && <p style={{ textAlign: "center", color: "#999", marginTop: 24, fontSize: 14 }}>{canEdit ? "Dit seizoensplan heeft nog geen weken. Voeg hierboven de eerste week toe." : "Dit seizoensplan heeft nog geen weken."}</p>}
      {filteredWks.length === 0 && weekFilter.length > 0 && <p style={{ textAlign: "center", color: "#999", marginTop: 40, fontSize: 14 }}>Geen weken gevonden met deze tags</p>}
      {renderModal()}
    </div>
  );
}

function buildAllWeekTags(data, sel, wks) {
  var allWeekTags = [];
  if (data && sel && data[sel]) {
    wks.forEach(function (w) {
      var wk = data[sel][w];
      if (wk && wk.tags) wk.tags.forEach(function (t) { if (allWeekTags.indexOf(t) < 0) allWeekTags.push(t); });
    });
    allWeekTags.sort();
  }
  return allWeekTags;
}
